import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: dictate additions (Address Suggestions and Transcribe Audio).
 * Started from the lesson page in a new tab; never auto-started. It only points
 * at the controls, since both flows record from the officer's microphone.
 */
const tour: TutorialDefinition = {
  id: "dictate-additions",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Dictate additions",
  description: "Add to a report by voice with Address Suggestions or Transcribe Audio.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "dictate-additions",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report that has a draft. A report you just generated works best.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("addToReportButton"),
      waitFor: sel("addToReportButton"),
      waitTimeoutMs: 10000,
      title: "Address Suggestions",
      content:
        "Facts that belong somewhere specific go here. Choose Record Audio or Upload Audio, speak to the open items, and review each change the AI proposes.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("suggestionItem"),
      waitFor: sel("suggestionItem"),
      title: "What to speak to",
      content: "The open suggestions and placeholders are your checklist. Answer them in the recording.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("editorTranscribe"),
      waitFor: sel("editorTranscribe"),
      title: "Transcribe Audio",
      content:
        "Click in the narrative where the text should go, then use this button. Pick Enhanced Dictation to apply your Report Preferences, or Pure Dictation for a near-verbatim transcript.",
      disableBeacon: true,
      placement: "bottom",
    },
  ],
};

export default tour;
